import { Fragment } from "react";

interface FormStep {
  title: string;
  subTitle?: string;
}

const formStepsSeller: FormStep[] = [
  {
    title: "اطلاعات هویتی",
    subTitle: "اعتبار سنجی",
  },
  {
    title: "اطلاعات فروشگاه",
  },
  {
    title: "پروانه کسب",
  },
  {
    title: "حساب بانکی",
  },
  {
    title: "تایید فروشگاه",
  },
  {
    title: "ضمانت",
  },
  {
    title: "قرارداد",
  },
  {
    title: "مجاز به ثبت سفارش",
  },
];
const formStepsUser: FormStep[] = [
  {
    title: "اطلاعات هویتی",
    subTitle: "اعتبار سنجی",
  },
  {
    title: "اطلاعات سکونتی",
  },
  {
    title: "اطلاعات شغلی",
  },
  {
    title: "ثبت معرف",
  },
  {
    title: "انتخاب فروشگاه",
  },
  {
    title: "مجاز به درخواست وام",
  },
];

const formStepsDashboard: FormStep[] = [
  {
    title: "ثبت کالا",
  },
  {
    title: "انتخاب وام",
  },
  {
    title: "صدور فاکتور",
  },
  {
    title: "بارگذاری چک",
  },
  {
    title: "تایید فروشگاه",
  },
  {
    title: "برگه تحویل و قرارداد",
  },
  {
    title: "ارسال پرونده",
  },
  {
    title: "تکمیل سفارش",
  },
];

const StepsTitle = ({ isChildVisible, formNo, sellerOrUser }: any) => {
  return (
    <>
      <div
        id="toggle"
        className={
          isChildVisible
            ? "md:flex basis-1/6 mr-4 shadow-button_sm_hover pt-10 px-10 flex-col rounded-[20px] justify-center items-center custom-stepstitle-height max-h-[610px]"
            : "hidden"
        }
      >
        <div className=" h-full flex  relative">
          <h1 className="text-Title/20/Bold text-primary-800 mb-10 whitespace-nowrap absolute top-0">
            {sellerOrUser === "user" ? "ثبت نام متقاضی" : "ثبت نام فروشنده"}
          </h1>
          <ol className="relative flex flex-col mt-16 mb-6 justify-between text-gray-500 step-item border-gray-300 whitespace-nowrap">
            {sellerOrUser === "user"
              ? formStepsUser.map((step, index) => (
                  <Fragment key={index}>
                    <li className="ms-6 flex items-center">
                      <span
                        className={`absolute  flex items-center justify-center w-8 h-8 ${
                          formNo >= index + 1
                            ? "bg-green-100 rounded-full -start-4   "
                            : "bg-gray-100 rounded-full -start-4    "
                        }  `}
                      >
                        <svg
                          className={` ${
                            formNo >= index + 1
                              ? "text-green-500 "
                              : "text-gray-500 "
                          } svg-color-transition`}
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                        >
                          <path
                            id="Vector"
                            d="M8.10364 15C7.88604 15.0009 7.67673 14.9089 7.52049 14.7437L3.585 10.5775C3.50656 10.4939 3.44397 10.3943 3.40081 10.2844C3.35764 10.1745 3.33475 10.0563 3.33343 9.93674C3.33078 9.69522 3.41617 9.46244 3.57084 9.28961C3.7255 9.11678 3.93676 9.01806 4.15814 9.01516C4.37953 9.01226 4.5929 9.10543 4.75132 9.27416L8.10698 12.8251L15.2482 5.25881C15.4068 5.09007 15.6204 4.99701 15.8419 5.00007C16.0635 5.00314 16.2748 5.1021 16.4295 5.27517C16.5841 5.44824 16.6695 5.68125 16.6666 5.92294C16.6638 6.16463 16.5731 6.3952 16.4145 6.56393L8.6868 14.7437C8.53056 14.9089 8.32125 15.0009 8.10364 15Z"
                          />
                        </svg>
                      </span>
                      <h3
                        className={`font-medium leading-tight ${
                          formNo === index + 1
                            ? "text-gray-900"
                            : formNo < index + 2
                            ? "text-gray-400 "
                            : "text-green-500 "
                        }`}
                      >
                        {step.title}
                      </h3>
                    </li>
                    {index !== formStepsUser.length - 1 && (
                      <li
                        className={`text-BodyText/12/Regular leading-tight flex items-center gap-1 -mr-[5px] justify-start ${
                          formNo === index + 1
                            ? "text-gray-400"
                            : formNo < index + 1
                            ? "text-gray-400 "
                            : "text-green-500 "
                        }`}
                      >
                        <svg
                          className={`font-medium leading-tight ${
                            formNo === index + 1
                              ? "text-gray-400"
                              : formNo < index + 1
                              ? "text-gray-400 "
                              : "text-green-500 "
                          }`}
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="8"
                          viewBox="0 0 28 8"
                          fill="CurrentColor"
                        >
                          <path
                            d="M0 4L24 4"
                            stroke={`${
                              step.subTitle ? "CurrentColor" : "none"
                            }`}
                          />
                          <circle
                            cx="24"
                            cy="4"
                            r="4"
                            fill={`${step.subTitle ? "CurrentColor" : "none"}`}
                          />
                          <circle
                            cx="24"
                            cy="4"
                            r="3"
                            fill={`${step.subTitle ? "white" : "none"}`}
                          />
                        </svg>
                        {step.subTitle}
                      </li>
                    )}
                  </Fragment>
                ))
              : sellerOrUser === "seller"
              ? formStepsSeller.map((step, index) => (
                  <Fragment key={index}>
                    <li key={index} className="ms-6 flex items-center">
                      <span
                        className={`absolute  flex items-center justify-center w-8 h-8 ${
                          formNo >= index + 1
                            ? "bg-green-100 rounded-full -start-4   "
                            : "bg-gray-100 rounded-full -start-4    "
                        }`}
                      >
                        <svg
                          className={` ${
                            formNo >= index + 1
                              ? "text-green-500 "
                              : "text-gray-500 "
                          }`}
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                        >
                          <path
                            id="Vector"
                            d="M8.10364 15C7.88604 15.0009 7.67673 14.9089 7.52049 14.7437L3.585 10.5775C3.50656 10.4939 3.44397 10.3943 3.40081 10.2844C3.35764 10.1745 3.33475 10.0563 3.33343 9.93674C3.33078 9.69522 3.41617 9.46244 3.57084 9.28961C3.7255 9.11678 3.93676 9.01806 4.15814 9.01516C4.37953 9.01226 4.5929 9.10543 4.75132 9.27416L8.10698 12.8251L15.2482 5.25881C15.4068 5.09007 15.6204 4.99701 15.8419 5.00007C16.0635 5.00314 16.2748 5.1021 16.4295 5.27517C16.5841 5.44824 16.6695 5.68125 16.6666 5.92294C16.6638 6.16463 16.5731 6.3952 16.4145 6.56393L8.6868 14.7437C8.53056 14.9089 8.32125 15.0009 8.10364 15Z"
                          />
                        </svg>
                      </span>
                      <h3
                        className={`font-medium leading-tight ${
                          formNo === index + 1
                            ? "text-gray-900"
                            : formNo < index + 2
                            ? "text-gray-400 "
                            : "text-green-500 "
                        }`}
                      >
                        {step.title}
                      </h3>
                    </li>

                    {index !== formStepsSeller.length - 1 && (
                      <li
                        className={`text-BodyText/12/Regular leading-tight flex items-center gap-1 -mr-[5px] justify-start ${
                          formNo === index + 1
                            ? "text-gray-400"
                            : formNo < index + 1
                            ? "text-gray-400 "
                            : "text-green-500 "
                        }`}
                      >
                        <svg
                          className={`font-medium leading-tight ${
                            formNo === index + 1
                              ? "text-gray-400"
                              : formNo < index + 1
                              ? "text-gray-400 "
                              : "text-green-500 "
                          }`}
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="8"
                          viewBox="0 0 28 8"
                          fill="CurrentColor"
                        >
                          <path
                            d="M0 4L24 4"
                            stroke={`${
                              step.subTitle ? "CurrentColor" : "none"
                            }`}
                          />
                          <circle
                            cx="24"
                            cy="4"
                            r="4"
                            fill={`${step.subTitle ? "CurrentColor" : "none"}`}
                          />
                          <circle
                            cx="24"
                            cy="4"
                            r="3"
                            fill={`${step.subTitle ? "white" : "none"}`}
                          />
                        </svg>
                        {step.subTitle}
                      </li>
                    )}
                  </Fragment>
                ))
              : formStepsDashboard.map((step, index) => (
                  <div className="flex" key={index}>
                    <li key={index} className="ms-6 flex items-center">
                      <span
                        className={`absolute  flex items-center justify-center w-8 h-8 ${
                          formNo >= index + 1
                            ? "bg-green-100 rounded-full -start-4   "
                            : "bg-gray-100 rounded-full -start-4    "
                        }`}
                      >
                        <svg
                          className={` ${
                            formNo >= index + 1
                              ? "text-green-500 "
                              : "text-gray-500 "
                          }`}
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                        >
                          <path
                            id="Vector"
                            d="M8.10364 15C7.88604 15.0009 7.67673 14.9089 7.52049 14.7437L3.585 10.5775C3.50656 10.4939 3.44397 10.3943 3.40081 10.2844C3.35764 10.1745 3.33475 10.0563 3.33343 9.93674C3.33078 9.69522 3.41617 9.46244 3.57084 9.28961C3.7255 9.11678 3.93676 9.01806 4.15814 9.01516C4.37953 9.01226 4.5929 9.10543 4.75132 9.27416L8.10698 12.8251L15.2482 5.25881C15.4068 5.09007 15.6204 4.99701 15.8419 5.00007C16.0635 5.00314 16.2748 5.1021 16.4295 5.27517C16.5841 5.44824 16.6695 5.68125 16.6666 5.92294C16.6638 6.16463 16.5731 6.3952 16.4145 6.56393L8.6868 14.7437C8.53056 14.9089 8.32125 15.0009 8.10364 15Z"
                          />
                        </svg>
                      </span>
                      <h3
                        className={`font-medium leading-tight ${
                          formNo === index + 1
                            ? "text-gray-900"
                            : formNo < index + 2
                            ? "text-gray-400 "
                            : "text-green-500 "
                        }`}
                      >
                        {step.title}
                      </h3>
                    </li>

                    {index !== formStepsSeller.length - 1 && (
                      <li
                        className={`text-BodyText/12/Regular leading-tight flex items-center gap-1 -mr-[5px] justify-start ${
                          formNo === index + 1
                            ? "text-gray-400"
                            : formNo < index + 1
                            ? "text-gray-400 "
                            : "text-green-500 "
                        }`}
                      >
                        <svg
                          className={`font-medium leading-tight ${
                            formNo === index + 1
                              ? "text-gray-400"
                              : formNo < index + 1
                              ? "text-gray-400 "
                              : "text-green-500 "
                          }`}
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="8"
                          viewBox="0 0 28 8"
                          fill="CurrentColor"
                        >
                          <path
                            d="M0 4L24 4"
                            stroke={`${
                              step.subTitle ? "CurrentColor" : "none"
                            }`}
                          />
                          <circle
                            cx="24"
                            cy="4"
                            r="4"
                            fill={`${step.subTitle ? "CurrentColor" : "none"}`}
                          />
                          <circle
                            cx="24"
                            cy="4"
                            r="3"
                            fill={`${step.subTitle ? "white" : "none"}`}
                          />
                        </svg>
                        {step.subTitle}
                      </li>
                    )}
                  </div>
                ))}
          </ol>
        </div>
      </div>
    </>
  );
};

export default StepsTitle;
